import type { PartnerBrandKey } from '@/lib/brand-assets'

/**
 * Official public URLs for each institution's own website — used to make
 * every institutional logo a real outbound link (BR-109/UX-064). Only
 * institutions with a project-lead-approved public URL appear here; do not
 * add an entry without confirming the target is the institution's own
 * official site (SEC-BRAND-001: no unrelated third-party targets).
 */
export const institutionalLinks: Record<PartnerBrandKey, string> = {
  napai: 'https://napaincu.github.io/',
  ai4x: 'https://ai4x.ntpu.edu.tw/',
  'moe-ite': 'https://dept.moe.gov.tw/ED2700/',
  ncu: 'https://www.ncu.edu.tw/',
  ntpu: 'https://new.ntpu.edu.tw/',
  nthu: 'https://www.nthu.edu.tw/',
}
